import React from "react";
import { Table } from "react-bootstrap";

const SaplingDetail = () =>{
    return(
        <section className="sevenScopeSec reduceWasteSec">
        <div className="container-fluid">
        <div className="mb-3">
        <h2>Plantation under<span className="hdngBrkr">#एक पेड़ माँ के नाम</span></h2>
        </div>
        <div className="row justify-content-center">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">           
        <Table>
            <thead className="text-start">
                <tr>
                    <th>Sr. No.</th>
                    <th>State/UT</th>
                    <th>Saplings</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Andaman & Nicobar
                    Islands</td>
                    <td>14,667</td>
                </tr>
                <tr><td>2</td>
                    <td>Andhra Pradesh</td>
                    <td>21,50,304</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>Arunachal Pradesh</td>
                    <td>87,314</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>Assam</td>
                    <td>18,62,364</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>Bihar</td>
                    <td>38,14,780</td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>Chandigarh</td>
                    <td>9,556</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>Chhattisgarh</td>
                    <td>4,11,864</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>DNH&DD</td>
                    <td>17,106</td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>Delhi</td>
                    <td>3,42,053</td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>Goa</td>
                    <td>69,181</td>
                </tr>
                <tr>
                    <td>11</td>
                    <td>Gujarat</td>
                    <td>10,42,691</td>
                </tr>
                <tr>
                    <td>12</td>
                    <td>Haryana</td>
                    <td>13,37,568</td>
                </tr>
                <tr>
                    <td>13</td>
                    <td>Himachal Pradesh</td>
                    <td>5,97,649</td>
                </tr>
                <tr>
                    <td>14</td>
                    <td>Jammu &amp; Kashmir</td>
                    <td>8,49,730</td>
                </tr>
                <tr>
                    <td>15</td>
                    <td>Jharkhand</td>
                    <td>13,59,240</td>
                </tr>
                <tr>
                    <td>16</td>
                    <td>Karnataka</td>
                    <td>1,62,035</td>
                 </tr>
                <tr>
                    <td>17</td>
                    <td>Kerala</td>
                    <td>7,25,225</td>
                </tr>
                <tr>
                    <td>18</td>
                    <td>Ladakh</td>
                    <td>0</td>
                </tr>
                <tr>
                    <td>19</td>
                    <td>Lakshadweep </td>
                    <td>12,290</td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>Madhya Pradesh</td>
                    <td>32,74,568</td>
                </tr>
                <tr>
                    <td>21</td>
                    <td>Maharashtra</td>
                    <td>24,14,074</td>
                </tr>
                <tr>
                    <td>22</td>
                    <td>Manipur</td>
                    <td>1,00,488 </td>
                </tr>
                <tr>
                    <td>23</td>
                    <td>Meghalaya</td>
                    <td>1,08,710</td>
                </tr>
                <tr>
                    <td>24</td>
                    <td>Mizoram</td>
                    <td>96,395</td>
                </tr>
                <tr>
                    <td>25</td>
                    <td>Nagaland</td>
                    <td>96,788</td>
                </tr>
                <tr>
                    <td>26</td>
                    <td>Odisha</td>
                    <td>18,00,346</td>
                </tr>
                <tr>
                    <td>27</td>
                    <td>Puducherry</td>
                    <td>88,350</td>
                </tr>
                <tr>
                    <td>28</td>
                    <td>Punjab</td>
                    <td>12,18,065</td>
                </tr>
                <tr>
                    <td>29</td>
                    <td>Rajasthan</td>
                    <td>1,58,74,835</td>
                </tr>
                <tr>
                    <td>30</td>
                    <td>Sikkim</td>
                    <td>44,250</td>
                </tr>
                <tr>
                    <td>31</td>
                    <td>Tamil Nadu</td>
                    <td>23,10,945</td>
                </tr> 
                <tr>
                    <td>32</td>
                    <td>Telangana</td>
                    <td>10,41,975</td>
                </tr>
                <tr>
                    <td>33</td>
                    <td>Tripura</td>
                    <td>1,42,693</td>
                </tr>
                <tr>
                    <td>34</td>
                    <td>Uttar Pradesh</td>
                    <td>87,89,813</td>
                </tr>
                <tr>
                    <td>35</td>
                    <td>Uttarakhand </td>
                    <td>7,99,075</td>
                </tr> 
                <tr>
                    <td>36</td>
                    <td>West Bengal</td>
                    <td>22,99,466</td>
                </tr>
                <tr>
                    <td></td>
                    <td>Total</td>
                    <td>5,53,66,463</td>
                </tr>
            </tbody>
        </Table>
        </div>
        </div>
        </div>
        </section>
    )
}
export default SaplingDetail;